import script from "./UpVercalculo.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpVercalculo.vue?vue&type=script&lang=ts&setup=true"

import "./UpVercalculo.vue?vue&type=style&index=0&id=419ce84a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-419ce84a"]])

export default __exports__